import api from "./api";

export const getReportsAll = async(status?: string, date?: Date, plant?: string) => {
    const response = await api.get(`reports/listAll?status=${status ? status : ""}&date=${date ? date : ""}&plant=${plant ? plant : ""}&orderby=data`);
    return response.data;
};

export const getReportsAllPagination = async(status?: string, date?: Date, plant?: string, plantName?: string, limit?: number, page?: number) => {
    const response = await api.get(`reports/listAllPagination?status=${status ? status : ""}&date=${date ? date : ""}&plant=${plant ? plant : ""}${plantName && plantName !== "" ? `&plantName=${plantName}` : ""}&limit=${limit ? limit : ""}&page=${page ? page : ""}`);
    return response.data;
};

export const getReportsAllAnt = async(status: string, plant: string, dateAnt: any, dateLast12Months?: any) => {
    const response = await api.get(`reports/listAll?activatePlant=true${status ? `&status=${status}` : ""}${dateAnt ? `&dateAnt=${dateAnt}` : ""}${plant ? `&plant=${plant}` : ""}&orderBy=data${dateLast12Months ? `&dateLast12Months=${dateLast12Months}` : ""}`);
    return response.data;
};

export const getReportsAllAntPublic = async(status: string | null, plant: string | null, dateAnt: any | null, dateLast12Months?: any | null) => {
    const response = await api.get(`reports/listAllGeneral?activatePlant=true${status ? `&status=${status}` : ""}${dateAnt ? `&dateAnt=${dateAnt}` : ""}${plant ? `&plant=${plant}` : ""}&orderBy=data${dateLast12Months ? `&dateLast12Months=${dateLast12Months}` : ""}`);
    return response.data;
};



export const getReportsOne = async(id: string) => {
    const response = await api.get(`reports/${id}`);
    return response.data;
};


export const getReportsOnePublic = async(id: string) => {
    const response = await api.get(`reports/listOnePage/${id}`);
    return response.data;
};

export const putReportsOne = async(id: string, data: any) => {
    const response = await api.put(`reports/${id}`, data);
    return response.data;
};

export const putReportsGeneration = async(id: string, data: any) => {
    const response = await api.put(`reports/updateStatusGeneration/${id}`, data);
    return response.data;
};

export const putReportsStatusOne = async(id: string) => {
    const response = await api.put(`reports/updateStatusOne/${id}`);
    return response.data;
};

export const putReportsStatusOnePrimary = async(id: string, data: any) => {
    const response = await api.put(`reports/updateStatusOnePrimary/${id}`, data);
    return response.data;
};

export const postReportEnviationEmail = async (body: any) => {
    const response = await api.post(`reports/toSendReportsEmail/`, body);
    return response.data;
};
